<template lang="pug">
  .report
    PMultiSelect(v-model="reportOptions.whatToShow" title="o que mostrar" labelItem="name")

    PSelect(v-model="reportOptions.orderBy" title="ordenar por" labelItem="name" :options="reportOptions.whatToShow.loaded")

    .option
      span ordenação:
      PRadio.ordem(label="ascendente", v-model="reportOptions.reverse", option="true")
      PRadio.ordem(label="descendente", v-model="reportOptions.reverse", option="false")

    .button
      PButton(color="success" size="md" @click="generate('pdf')" :loading="loading.pdf" :disabled="!valid") gerar pdf
      PButton(color="success" size="md" @click="generate('excel')" :loading="loading.excel" :disabled="!valid") gerar excel

</template>

<script>
import moment from 'moment'

export default {
  props: {
    reportInfo: {type: Object},
    valid: {type: Boolean}
  },
  data () {
    const fields = [
      {id: 'absence', name: 'Total de Faltas'},
      {id: 'delay_time', name: 'Total de Atrasos'},
      {id: 'extra_time_50_tot', name: 'Total de Horas Extras Normais'},
      {id: 'extra_time_100_tot', name: 'Total de Horas Extras Extraordinárias'},
      {id: 'night_hours_50', name: 'Total de Adicional Noturno'},
      {id: 'presence', name: 'Total de Presença'},
      {id: 'early_exit', name: 'Total de Saída Antecipada'},
      {id: 'extra_time_50_not_tot', name: 'Hora Extra Noturna'},
      {id: 'extra_time_100_not_tot', name: 'Hora Extra Noturna Ext.'},
      {id: 'extra_time_special_not_tot', name: 'Hora Extra Noturna Esp.'}
    ]

    return {
      loading: {pdf: false, excel: false},
      reportOptions: {
        orderBy: fields[0].id,
        reverse: false,
        whatToShow: {
          selected: [...fields],
          loaded: fields
        }
      }
    }
  },
  methods: {
    async generate (typeReport) {
      this.loading[typeReport] = true

      const params = {
        // entity: this.reportInfo.entity,
        // entityContent: this.reportInfo.entityContent.map(i => i.id),
        toShow: this.reportOptions.whatToShow.selected.map(i => i.id),
        orderBy: this.reportOptions.orderBy,
        reverse: this.reportOptions.reverse,
        typeReport,
        startDate: moment(this.reportInfo.periodData.startDate).format('DD-MM-YY'),
        endDate: moment(this.reportInfo.periodData.endDate).format('DD-MM-YY')
      }

      if (this.reportInfo.entity === 'companies') {
        params.companies = this.reportInfo.entityContent.map(i => i.id)
      }

      let result
      try {
        result = await this.$API.R04.save(params)
      } catch (e) {
        result = e
      }
      this.$emit('handleReport', result)

      this.loading[typeReport] = false
    }
  }
}
</script>

<style scoped lang="scss">
.report {
  display: grid;

  grid-template-columns: 1fr 1fr;
  grid-template-rows: 1fr 1fr;
  grid-column-gap: 10px;
  grid-row-gap: 20px;

  .option{
    display: grid;
    grid-template-columns: max-content 1fr;
    grid-column-gap: 20px;

    > span {
      grid-row-start: 1;
    }
    .ordem {
      grid-row-start: 2;
    }
  }
  .button {
    grid-column-start: 2;

    justify-self: end;
    align-self: end;
    display: grid;
    grid-auto-columns: 1fr max-content;
    grid-auto-flow: column;
    grid-column-gap: 10px;
  }
}
</style>
